import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

document.querySelector('html').style.height = '100%';
const rootElement = document.getElementById('root');
rootElement.style.height = '100%';
const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
	<React.StrictMode>
		<App />
	</React.StrictMode>,
);
